import { render } from "./SelectView.vue?vue&type=template&id=28bc389f"
import script from "./SelectView.vue?vue&type=script&lang=js"
export * from "./SelectView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__